import React from "react";
import { X } from "lucide-react";

const RepresentativePeopleSection = ({
  formValues,
  setValue
}) => {
  const handleAddPerson = () => {
    const fullNameInput = document.getElementById('repFullName');
    const emailInput = document.getElementById('repEmail');
    const phoneInput = document.getElementById('repPhone');
    const fullName = fullNameInput?.value.trim();
    
    if (fullName) {
      const newPerson = {
        fullName: fullName,
        email: emailInput?.value.trim() || '',
        phoneNumber: phoneInput?.value.trim() || ''
      };
      setValue('representativePeoples', [...(formValues.representativePeoples || []), newPerson]);
      if (fullNameInput) fullNameInput.value = '';
      if (emailInput) emailInput.value = '';
      if (phoneInput) phoneInput.value = '';
    }
  };

  const handleRemovePerson = (index) => {
    const newPeople = (formValues.representativePeoples || []).filter((_, i) => i !== index);
    setValue('representativePeoples', newPeople);
  };

  const representativePeoples = Array.isArray(formValues.representativePeoples) 
    ? formValues.representativePeoples.filter(person => person && person.fullName)
    : [];

  return (
    <div className="form-section">
      <span className="section-title">Representative People</span>
      <div className="form-field">
        <label className="form-label">
          Add contact persons for this customer (optional)
        </label>
        
        {representativePeoples.length > 0 && (
          <div className="selected-items-list selected-items-list--with-margin">
            {representativePeoples.map((person, index) => {
              const fullName = person.fullName || '';
              const email = person.email || '';
              const phoneNumber = person.phoneNumber || '';
              
              return (
                <div key={`person-${index}-${fullName}`} className="selected-item-tag">
                  <span>
                    {fullName}
                    {email && ` - ${email}`}
                    {phoneNumber && ` - ${phoneNumber}`}
                  </span>
                  <button
                    type="button"
                    className="remove-tag-button"
                    onClick={() => handleRemovePerson(index)}
                  >
                    <X size={14} />
                  </button>
                </div>
              );
            })}
          </div>
        )}

        <div className="add-person-form">
          <h4 className="add-person-form__title">Add New Person</h4>
          <div className="add-person-form__fields">
            <div className="form-field">
              <label htmlFor="repFullName" className="form-label">Full Name *</label>
              <input
                type="text"
                placeholder="Full Name"
                id="repFullName"
                className="form-input"
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    handleAddPerson();
                  }
                }}
              />
            </div>
            <div className="form-field">
              <label htmlFor="repEmail" className="form-label">Email</label>
              <input
                type="email"
                placeholder="email@example.com"
                id="repEmail"
                className="form-input"
              />
            </div>
            <div className="form-field">
              <label htmlFor="repPhone" className="form-label">Phone Number</label>
              <input
                type="tel"
                placeholder="Phone Number"
                id="repPhone"
                className="form-input"
              />
            </div>
            <button
              type="button"
              onClick={handleAddPerson}
              className="add-person-form__button"
            >
              Add Person
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RepresentativePeopleSection;

